import { Component, OnInit, HostBinding } from '@angular/core';
import { ApplicationService } from './application-service/application.service';
import { SessionTimeoutService } from '../app/session-service/sessiontimeoutservice';
import { AuthenticationService } from './authentication-service/authentication.service';

declare const System: any;

@Component({
    selector: 'wbm-app',
    templateUrl: './app.component.html',
    styleUrls: ['../assets/theme/css/app.css']
})
export class AppComponent implements OnInit {

    @HostBinding() class = 'wbm-app';
    public options = {
        timeOut: 1000,
        clickToClose: true,
        showProgressBar: false,
        animate: 'fromLeft',
        pauseOnHover: true,
        maxStack: 2
    };

    private tokenExpiryInterval: any;

    constructor(private _application: ApplicationService,  private sessionTimeoutService: SessionTimeoutService, private _authService: AuthenticationService) { }

    public ngOnInit() {
        this._application.setupApplicationLanguage();
        // Remove the automatic token expiry check - let SessionTimeoutService handle it with confirmation
        // this.tokenExpiryInterval = setInterval(() => {
        //     const token = sessionStorage.getItem('id_token');
        //     if (token && this._authService.isTokenExpired(token)) {
        //         console.log('[AppComponent] Token expired, logging out');
        //         this._authService.logout();
        //     }
        // }, 1000);
    }

    ngOnDestroy() {
        // Cleanup removed since we're no longer using the interval
        // if (this.tokenExpiryInterval) {
        //     clearInterval(this.tokenExpiryInterval);
        // }
    }
}
